import React from 'react';
import {Carousel} from "antd";

import one from "../../assets/images/1.png";
import two from "../../assets/images/2.png";
import three from "../../assets/images/3.png";
const QuotesSection =()=>{
    return(
        
      <Carousel autoplay >
      <div className="slidediv">
        <img src={one} alt=""></img>

        <h2>
          {" "}
          “ Coding is the language of the future, and every girl should learn
          it. As I've learned from watching girls grow and learn in our
          classrooms, coding is fun, collaborative and creative. ” <br /> -
          Reshma Saujani
        </h2>
      </div>
      <div className="slidediv">
        <img src={two} alt=""></img>
        <h2>
          “I think it's fair to say that personal computers have become the
          most empowering tool we've ever created. They're tools of
          communication, they're tools of creativity, and they can be shaped
          by their user.” <br /> - Bill Gates
        </h2>
      </div>
      <div className="slidediv">
        <img src={three} alt=""></img>
        <h2>
          “Whether you want to uncover the secrets of the universe, or you
          just want to pursue a career in the 21st century, basic computer
          programming is an essential skill to learn.” <br /> - Stephen
          Hawking
        </h2>
      </div>
    </Carousel>
    )
}

export default QuotesSection;